import React, { Component } from 'react';
// import TextField from 'material-ui/TextField';
import { TextField, Button } from 'react-md';

import LogoZ from '../SVG/LogoZ';

export default class LoginViewCentral extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
            zusername: "",
            zpassword: "",
            yusername: "",
            ypassword: "",
            femail: "",
            femailLoading: 0,

            nusername: "",
            npassword: "",
            npasswordConfirm: "",
            firstName: this.props.autoFillInfo != undefined ? this.props.autoFillInfo.firstName : "",
            lastName: this.props.autoFillInfo != undefined ? this.props.autoFillInfo.lastName : "",
            phone: this.props.autoFillInfo != undefined ? this.props.autoFillInfo.phone : "",
            email: this.props.autoFillInfo != undefined ? this.props.autoFillInfo.email : "",
            googleId: "",
            facebookId: "",
            instagramId: "",
            errors: {
                un: null,
                password: null,
                passwordConfirm: null,
                email: null,
                phone: null
            }
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.changeSubmode = this.changeSubmode.bind(this);

        this.capitalizeFirstLetter = this.capitalizeFirstLetter.bind(this);
        this.checkErrors = this.checkErrors.bind(this);
        this.checkEmail = this.checkEmail.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);
        this.createNewAccount = this.createNewAccount.bind(this);
        this.generatePassword = this.generatePassword.bind(this);
        this.isAcceptable = this.isAcceptable.bind(this);
    }

    componentDidMount() { }

    componentWillReceiveProps() {

        if (this.props.mode != 'new') {
            this.setState({
                yusername: "",
                ypassword: "",
                femail: "",
                femailLoading: 0,
                nusername: "",
                npassword: "",
                npasswordConfirm: "",
                firstName: this.props.autoFillInfo != undefined ? this.props.autoFillInfo.firstName : "",
                lastName: this.props.autoFillInfo != undefined ? this.props.autoFillInfo.lastName : "",
                phone: this.props.autoFillInfo != undefined ? this.props.autoFillInfo.phone : "",
                email: this.props.autoFillInfo != undefined ? this.props.autoFillInfo.email : ""
            });

            if (this.props.mode === 'main') {
                this.checkErrors();
            }
        }
    }

    handleInputChange(property, value, e) {

        let val = e.target.value;

        if (["zusername", "zpassword", "femail", "yusername", "ypassword", "nusername", "npassword", "npasswordConfirm", "email"].includes(property)) {
            val = val.trim();
        }

        if (val.length <= 100) {
            if (this.props.mode === 'forgot') {
                this.setState({ [property]: val, femailLoading: 0 });
            } else if (this.props.mode != 'new') {
                this.setState({ [property]: val });
            } else {
                this.setState({ [property]: val }, () => {
                    this.checkErrors();
                });
            }
        }
    }

    changeSubmode(mode) {
        this.props.changeSubView(mode);
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    checkErrors() {
        var tempErrors = this.state.errors;

        if (this.state.nusername != "") {
            tempErrors.un = null;
            if (this.state.nusername.length < 8) {
                tempErrors.un = "Must be at least 8 characters";
            }
        } else {
            tempErrors.un = null;
        }
        if (this.state.npassword != "") {
            tempErrors.password = null;
            if (this.state.npassword.length < 8) {
                tempErrors.password = "Must be at least 8 characters";
            }
            if (this.state.npassword.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/) == null) {
                tempErrors.password = "Must contain at least 1 special character";
            }
            if (this.state.npassword.match(/[a-z]/) == null) {
                tempErrors.password = "Must contain at least 1 lower case letter";
            }
            if (this.state.npassword.match(/[A-Z]/) == null) {
                tempErrors.password = "Must contain at least 1 upper case letter";
            }
            if (this.state.npassword.match(/[0-9]/) == null) {
                tempErrors.password = "Must contain at least 1 number";
            }

        } else {
            tempErrors.password = null;
        }
        if (this.state.npasswordConfirm != "") {
            tempErrors.passwordConfirm = null;
            if (this.state.npasswordConfirm.trim() != this.state.npassword.trim()) {
                tempErrors.passwordConfirm = "Passwords do not match";
            }

        } else {
            tempErrors.passwordConfirm = null;
        }
        if (this.state.email != "") {
            tempErrors.email = null;
            if (this.state.email.match(/^([a-zA-Z0-9_]+[\.\+])*[a-zA-Z0-9_]+@([a-zA-Z0-9]+\.)*[a-zA-Z0-9]+\.[a-zA-Z]+$/) == null) {
                tempErrors.email = "Invalid Email";
            }

        } else {
            tempErrors.email = null;
        }
        if (this.state.phone != '') {
            tempErrors.phone = null;
            if (this.state.phone.match(/^[0-9.-]{10,}$/) === null) {
                tempErrors.phone = "Invalid Phone Number"
            }
        } else {
            tempErrors.phone = null;
        }


        this.setState({ errors: tempErrors });
    }

    checkEmail() {
        return (this.state.femail != "" &&
            this.state.femail.match(/^([a-zA-Z0-9_-]+[\.\+])*[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)*[a-zA-Z0-9]+\.[a-zA-Z]+$/) == null)
    }

    handleForgotPassword() {
        var self = this;

        this.setState({ femailLoading: 1 });
        if (!this.checkEmail() && this.state.femail != '') {
            this.props.handleForgotPassword(this.state.femail, (res) => {
                if (self.props.mode === 'forgot') {
                    self.setState({ femailLoading: 2 });

                    setTimeout(() => {
                        self.props.changeView('main');
                    }, 1000);
                }
            }, (err) => {
                if (self.props.mode === 'forgot') {
                    self.setState({ femailLoading: 3 });
                }
            });
        }
    }

    createNewAccount() {

        if (this.isAcceptable()) {
            this.props.createNewAccount({
                username: this.state.nusername,
                password: this.state.npassword,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                phoneNumber: this.state.phone,
                email: this.state.email,
                googleId: (this.props.externalInfo.type === "google" ? this.props.externalInfo.id : null),
                facebookId: (this.props.externalInfo.type === "facebook" ? this.props.externalInfo.id : null),
                instagramId: (this.props.externalInfo.type === "instagram" ? this.props.externalInfo.id : null),
                googlePicUrl: (this.props.externalInfo.type === "google" ? this.props.autoFillInfo.picture : null),
                facebookPicUrl: (this.props.externalInfo.type === "facebook" ? this.props.autoFillInfo.picture : null),
                instagramPicUrl: (this.props.externalInfo.type === "instagram" ? this.props.autoFillInfo.picture : null),
            });
        }
    }

    generatePassword() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";

        var limit = Math.floor(Math.random() * 10) + 10
        for (var i = 0; i < limit; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    isAcceptable() {

        return (
            this.state.nusername != "" && this.state.nusername != null && this.state.nusername != undefined &&
            this.state.npassword != "" && this.state.npassword != null && this.state.npassword != undefined &&
            this.state.npasswordConfirm != "" && this.state.npasswordConfirm != null && this.state.npasswordConfirm != undefined &&
            this.state.firstName != "" && this.state.firstName != null && this.state.firstName != undefined &&
            this.state.lastName != "" && this.state.lastName != null && this.state.lastName != undefined &&
            this.state.phone != "" && this.state.phone != null && this.state.phone != undefined &&
            this.state.email != "" && this.state.email != null && this.state.email != undefined &&
            this.state.errors.un === null && this.state.errors.password === null &&
            this.state.errors.passwordConfirm === null && this.state.errors.email === null &&
            this.state.errors.phone === null
        );
    }

    render() {

        var offTextValue = 'calc(100% + 3.6rem)';

        var loginWaterfallTopStart = '105vh';
        var loginWaterfall = ['0s', '0.2s', '0.4s', '0.6s', '0.8s'];
        var loginWaterfallTop = ['15.7rem', '20.53rem', '23.367rem', '27.2rem', 'calc(100% - 4.0rem)'];

        var loginZClass = 'login-card-button';
        var zloginButtonAction = null;
        var zloginSwitcher = null;
        var cardInnerContainer = null;
        var errorMessage = null;
        if (this.props.loginErrorMessage != null) {
            errorMessage = (<div class="error" >{this.props.loginErrorMessage}</div>)
        }

        if (this.props.submode === 'main' && this.props.mode === 'main') {
            zloginButtonAction = this.changeSubmode.bind(null, 'zlogin');
        } else if (this.props.submode === 'zlogin' && this.props.mode === 'main') {
            loginZClass += ' login-zlogin-container';
            var loginWaterfall = [null, '0s', '0s', '0s'];
            loginWaterfallTop = ['9.5rem', '13.1rem', '29.5rem', '32.8rem', offTextValue];
            zloginSwitcher = (
                <div className="login-switcher" style={{ top: '7rem', transition: 'top 0.2s ease-in-out 0.2s' }}>
                    <div className="login-switcher-button login-switcher-button-bigger" onClick={this.props.changeViewExternal.bind(null, 'main').bind(null, '').bind(null, '')}>Sign in</div>
                    {usingiOS && window.cordova != undefined ? null : <div className="login-switcher-button" onClick={this.props.changeView.bind(null, 'new')}>Sign up</div>}
                </div>
            )
            cardInnerContainer = (
                <div className="login-card-inner-container" style={{ opacity: this.props.innerOpacity }}>
                    <TextField className="z-md-textfield"
                        key="zzusernamefield"
                        fullWidth={true}
                        onChange={this.handleInputChange.bind(null, 'zusername')}
                        value={this.state.zusername}
                        type="text"
                        label="Username" />
                    <TextField className="z-md-textfield no-margin-bottom"
                        key="zzpasswordfield"
                        fullWidth={true}
                        onChange={this.handleInputChange.bind(null, 'zpassword')}
                        value={this.state.zpassword}
                        type="password"
                        label="Password" />
                    <div className="login-forgot-password-container" onClick={this.props.changeView.bind(null, 'forgot')}>Forgot Password?</div>
                    {errorMessage}
                    <div className="login-zlogin-login-button" onClick={this.props.handleStandardLogin.bind(null, this.state.zusername).bind(null, this.state.zpassword)}>Sign in</div>
                </div>
            );
        } else if (this.props.mode === 'forgot') {
            loginZClass += ' login-zlogin-container';
            var loginWaterfall = [null, '0s', '0s', '0s'];
            loginWaterfallTop = ['9.5rem', '13.1rem', '29.5rem', '32.8rem', offTextValue];
            zloginSwitcher = (
                <div className="login-switcher" style={{ top: '7rem', transition: 'top 0.2s ease-in-out 0.2s' }}>
                    <div className="login-switcher-button login-switcher-button-bigger" onClick={this.props.changeViewExternal.bind(null, 'main').bind(null, '').bind(null, '')}>Sign in</div>
                    {usingiOS && window.cordova != undefined ? null : <div className="login-switcher-button" onClick={this.props.changeView.bind(null, 'new')}>Sign in</div>}
                </div>
            )
            var emailLoadingJsx = null;
            switch (this.state.femailLoading) {
                case 1:
                    emailLoadingJsx = (
                        <div className="login-forgot-loading-container">
                            <svg className="login-forgot-loading-envelope" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" />
                            </svg>
                        </div>
                    );
                    break;
                case 2:
                    emailLoadingJsx = (
                        <div className="login-forgot-loading-container">
                            <svg className="login-forgot-loading-check" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                            </svg>
                        </div>
                    );
                    break;
                case 3:
                    emailLoadingJsx = (
                        <div className="login-forgot-loading-container">
                            <svg className="login-forgot-loading-close" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                            </svg>
                        </div>
                    );
                    break;
            }
            cardInnerContainer = (
                <div className="login-card-inner-container" style={{ opacity: this.props.innerOpacity }}>
                    <div className="login-forgot-message">
                        Would you like to send a link to reset your password?
                    </div>
                    <TextField className="z-md-textfield z-md-textfield-m2p2"
                        key="zzforgotfield"
                        disabled={this.state.femailLoading === 1}
                        fullWidth={true}
                        onChange={this.handleInputChange.bind(null, 'femail')}
                        value={this.state.femail}
                        defaultValue=""
                        error={this.state.femailLoading === 3 || this.checkEmail()}
                        errorText={this.state.femailLoading === 3 ? "Server Error" : "Invalid Email"}
                        type="text"
                        label="Email" />
                    <div className="login-double-button-container">
                        <Button flat disabled={this.state.femailLoading === 1 || this.state.femail === "" || this.checkEmail()} className="login-double-login-button" onClick={this.handleForgotPassword}>Send</Button>
                        <Button flat className="login-double-login-button" onClick={this.props.changeView.bind(null, 'main')}>Cancel</Button>
                    </div>
                    {emailLoadingJsx}
                </div>
            );
        } else if (this.props.mode === 'you') {
            loginZClass += ' login-you-container';
            var loginWaterfall = [null, '0s', '0s', '0s'];
            loginWaterfallTop = ['8.85rem', offTextValue, offTextValue, offTextValue, offTextValue];
            cardInnerContainer = (
                <div className="login-card-inner-container" style={{ opacity: this.props.innerOpacity }}>
                    <div className="login-card-inner-message">{"A Zeezor account was found with the same email address as this " + this.capitalizeFirstLetter(this.props.externalInfo.type) + " account. Please verify and enter your ZeeZor password to link the accounts."}</div>
                    <TextField className="z-md-textfield"
                        fullWidth={true}
                        value={this.props.internalInfo.email}
                        type="text"
                        label="Email"
                        disabled={true} />
                    <TextField className="z-md-textfield"
                        fullWidth={true}
                        onChange={this.handleInputChange.bind(null, 'yusername')}
                        value={this.state.yusername}
                        type="text"
                        label="Username" />
                    <TextField className="z-md-textfield no-margin-bottom"
                        fullWidth={true}
                        onChange={this.handleInputChange.bind(null, 'ypassword')}
                        value={this.state.ypassword}
                        type="password"
                        label="Password" />
                    <div className="login-forgot-password-container" onClick={this.props.changeView.bind(null, 'forgot')}>Forgot Password?</div>
                    <div className="login-double-button-container">
                        <Button flat className="login-double-login-button" onClick={this.props.handleLoginAddSocial.bind(null, this.state.yusername).bind(null, this.state.ypassword)}>Link</Button>
                        <Button flat className="login-double-login-button" onClick={this.props.changeViewExternal.bind(null, 'main').bind(null, '').bind(null, '')}>Cancel</Button>
                    </div>
                </div>
            );
        } else if (this.props.mode === 'zconfirm') {
            loginZClass += ' login-you-container';
            var loginWaterfall = [null, '0s', '0s', '0s'];
            loginWaterfallTop = ['8.85rem', offTextValue, offTextValue, offTextValue, offTextValue];
            cardInnerContainer = (
                <div className="login-card-inner-container" style={{ opacity: this.props.innerOpacity }}>
                    <div className="login-card-inner-message">{"A ZeeZor account was not found to be associated with your " + this.capitalizeFirstLetter(this.props.externalInfo.type) + " account. Please enter your ZeeZor username and password to link the accounts."}</div>
                    <TextField className="z-md-textfield"
                        fullWidth={true}
                        onChange={this.handleInputChange.bind(null, 'yusername')}
                        value={this.state.yusername}
                        type="text"
                        label="Username" />
                    <TextField className="z-md-textfield no-margin-bottom"
                        fullWidth={true}
                        onChange={this.handleInputChange.bind(null, 'ypassword')}
                        value={this.state.ypassword}
                        type="password"
                        label="Password" />
                    <div className="login-forgot-password-container" onClick={this.props.changeView.bind(null, 'forgot')}>Forgot Password?</div>
                    <div className="login-double-button-container" style={{ margin: '1.2rem 0 0' }}>
                        <Button flat className="login-double-login-button" onClick={this.props.handleLoginAddSocial.bind(null, this.state.yusername).bind(null, this.state.ypassword)}>Link</Button>
                        <Button flat className="login-double-login-button" onClick={this.props.changeViewExternal.bind(null, 'main').bind(null, '').bind(null, '')}>Cancel</Button>
                    </div>
                    {usingiOS && window.cordova != undefined ? null : (
                        <div className="login-zconfirm-new-account-container">
                            <div className="login-zconfirm-new-account-text">Don't have an account yet?</div>
                            <div className="login-zconfirm-new-account-button" onClick={this.props.changeView.bind(null, 'new')}>Sign up</div>
                        </div>
                    )}
                </div>
            );
        } else if (this.props.mode === 'new') {

            let newConfirmJsx;
            let imageJsx = null;
            if (this.props.externalInfo.type != undefined && this.props.externalInfo.type != null && this.props.externalInfo.type != "") {
                let signUpButtonClass = "login-double-login-button";
                if (!this.isAcceptable()) {
                    signUpButtonClass += " login-button-disabled";
                }
                newConfirmJsx = usingiOS && window.cordova != undefined ? null : (
                    <div className="login-double-button-container">
                        <Button flat className={signUpButtonClass} onClick={this.createNewAccount}>Sign up</Button>
                        <Button flat className="login-double-login-button" onClick={this.props.changeViewExternal.bind(null, 'main').bind(null, '').bind(null, '')}>Cancel</Button>
                    </div>
                );
                imageJsx = (<img className="login-new-picture" src={this.props.autoFillInfo.picture} />);
            } else {
                let signUpButtonClass = "login-new-login-button";
                if (!this.isAcceptable()) {
                    signUpButtonClass += " login-button-disabled";
                }
                newConfirmJsx = usingiOS && window.cordova != undefined ? null : (
                    <Button flat className={signUpButtonClass} onClick={this.createNewAccount}>Sign up</Button>
                );
                imageJsx = (<div className="login-new-picture-icon material-icons">person</div>);
                zloginSwitcher = (
                    <div className="login-switcher" style={{ top: '-2.5rem' }}>
                        <div className="login-switcher-button" onClick={this.props.changeView.bind(null, 'remain')}>Sign in</div>
                        {usingiOS && window.cordova != undefined ? null : <div className="login-switcher-button login-switcher-button-bigger">Sign up</div>}
                    </div>
                )
            }

            loginZClass += ' login-new-container';
            var loginWaterfall = [null, '0s', '0s', '0s'];
            loginWaterfallTop = ['0.2rem', offTextValue, offTextValue, offTextValue, offTextValue];
            cardInnerContainer = (
                <div className="login-card-inner-container" style={{ opacity: this.props.innerOpacity }}>
                    <div className="login-new-picture-container">
                        {imageJsx}
                    </div>
                    <TextField className="z-md-textfield"
                        fullWidth={true}
                        error={this.state.errors.un != null}
                        errorText={this.state.errors.un}
                        onChange={this.handleInputChange.bind(null, 'nusername')}
                        value={this.state.nusername}
                        type="text"
                        label="Username" />
                    <TextField className="z-md-textfield"
                        fullWidth={true}
                        error={this.state.errors.password != null}
                        errorText={this.state.errors.password}
                        onChange={this.handleInputChange.bind(null, 'npassword')}
                        value={this.state.npassword}
                        type="password"
                        label="Password" />
                    <TextField className="z-md-textfield"
                        fullWidth={true}
                        error={this.state.errors.passwordConfirm != null}
                        errorText={this.state.errors.passwordConfirm}
                        onChange={this.handleInputChange.bind(null, 'npasswordConfirm')}
                        value={this.state.npasswordConfirm}
                        type="password"
                        label="Confirm Password" />
                    <div className="login-double-textfield-container">
                        <TextField className="z-md-textfield z-md-textfield-half"
                            fullWidth={false}
                            onChange={this.handleInputChange.bind(null, 'firstName')}
                            value={this.state.firstName}
                            type="text"
                            label="First" />
                        <TextField className="z-md-textfield z-md-textfield-half"
                            fullWidth={false}
                            onChange={this.handleInputChange.bind(null, 'lastName')}
                            value={this.state.lastName}
                            type="text"
                            label="Last" />
                    </div>
                    <TextField className="z-md-textfield z-md-textfield-m0p8"
                        fullWidth={true}
                        error={this.state.errors.email != null}
                        errorText={this.state.errors.email}
                        onChange={this.handleInputChange.bind(null, 'email')}
                        value={this.state.email}
                        type="text"
                        label="Email" />
                    <TextField className="z-md-textfield z-md-textfield-m0p7"
                        fullWidth={true}
                        error={this.state.errors.phone != null}
                        errorText={this.state.errors.phone}
                        onChange={this.handleInputChange.bind(null, 'phone')}
                        value={this.state.phone}
                        type="tel"
                        label="Phone" />
                    {newConfirmJsx}
                </div>
            );
        }

        var loginView = null;
        if (this.props.mode === 'splash') {
            loginView = (
                <div className="login-view-scroller-outer">
                    <div className={"scroller-spacer scroller-spacer-" + this.props.mode}>
                        <div className="login-view-container login-view-container-splash">
                            <div className="login-card-button" style={{ top: loginWaterfallTopStart }}>
                                <div className="login-card-button-icon">
                                    <LogoZ className="login-card-button-icon-graphic" />
                                </div>
                                <div className="login-card-button-text">Sign in</div>
                            </div>
                            <div className="login-card-button" style={{ top: loginWaterfallTopStart }}>
                                <div className="login-card-button-icon">
                                    <img className="login-card-button-icon-graphic" src={window.__globalConfig.contentUrl + "images/facebook-white.svg"} />
                                </div>
                                <div className="login-card-button-text">Sign in</div>
                            </div>
                            <div className="login-card-button" style={{ top: loginWaterfallTopStart }}>
                                <div className="login-card-button-icon">
                                    <img className="login-card-button-icon-graphic" src={window.__globalConfig.contentUrl + "images/instagram-logo-white.svg"} />
                                </div>
                                <div className="login-card-button-text">Sign in</div>
                            </div>
                            <div className="login-card-button" style={{ top: loginWaterfallTopStart }}>
                                <div className="login-card-button-icon">
                                    <img className="login-card-button-icon-graphic" src={window.__globalConfig.contentUrl + "images/google-white.svg"} />
                                </div>
                                <div className="login-card-button-text">Sign in</div>
                            </div>
                            <div className="login-tour-button" style={{ top: loginWaterfallTop[4] }}>{"PRIVACY POLICY"}</div>
                        </div>
                    </div>
                </div>
            );
        } else {

            let outermostClass = "login-view-container login-view-container-main login-view-container-main-" + this.props.mode;

            loginView = (
                <div className="login-view-scroller-outer">
                    <div className={"scroller-spacer scroller-spacer-" + this.props.mode}>
                        <div className={outermostClass}>
                            <div className={loginZClass} onClick={zloginButtonAction} style={{ top: loginWaterfallTop[1], transitionDelay: loginWaterfall[0] }}>
                                <div className="login-card-button-icon">
                                    <LogoZ style={{ fill: "#ffffff" }} className="login-card-button-icon-graphic" />
                                </div>
                                <div className="login-card-button-text">Sign in</div>
                                {cardInnerContainer}
                            </div>
                            <div className="login-view-headline" style={{ top: loginWaterfallTop[0], transitionDelay: loginWaterfall[3], opacity: this.props.submode === 'main' ? '1' : '0' }}>Welcome to Insights</div>                                
                            <div className="login-tour-button" style={{ top: loginWaterfallTop[4], transitionDelay: loginWaterfall[4], opacity: this.props.submode === 'main' ? '1' : '0' }} onClick={this.props.viewPrivacyPolicy}>{"Privacy Policy"}</div>
                        </div>
                    </div>
                </div>
            );
        }

        return loginView;
    }
}
